import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from '../auth/auth.guard';
import { ThemeResolver } from '../../theme/theme.resolver';
import { ConfigureChannelComponent } from './configure/configure.component';

const routes: Routes = [
  {
    path: 'channel/configure',
    component: ConfigureChannelComponent,
    canActivate: [AuthGuard],
    data: { title: 'channel.configure_channel' },
    resolve: { theme: ThemeResolver }
  }
];

export const router: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// ./src/app/modules/channel/channel.routes.ts